import axios from 'axios';

/**
 * Fetch currency via Busabout API
 */
export async function FetchCurrency() {

    const CURRENCY_URL = process.env.REACT_APP_TMS_CURRENCY_API;

    try{
      const data = await axios.get(CURRENCY_URL);
      return data;
    }
    catch(err){
      console.error(err);
    };
}